// component for admin private route
import React, { useState, useEffect } from "react";
import { Route, useLocation, useHistory } from "react-router-dom";
import MasterLayout from "../../layouts/admin/MasterLayout";
import privateApi from "../../services/privateApi";
import { saveData, getSchool, getToken } from "../../services/auth/token";

const AdminPrivateRoute = ({ ...rest }) => {
  const history = useHistory();
  const location = useLocation();

  const [Authenticated, setAuthenticated] = useState(false);
  const [loading, setloading] = useState(true);

  const authChecker = async e => {
    const schoolSlug = getSchool() ? "/" + getSchool() : "";
    if (!getToken()) {
      history.push(schoolSlug + "/login/admin");
      return;
    }

    const response = await privateApi.get("admin/me");

    if (response.status === 200) {
      setloading(false);
      setAuthenticated(true);
      saveData(JSON.stringify(response.data.data));
    } else {
      history.push(schoolSlug + "/login/admin");
      return;
    }
  };

  useEffect(() => {
    localStorage.setItem("previousPathname", location.pathname);
  }, [location]);

  useEffect(() => {
    authChecker();
  }, []);

  if (loading) {
    return <></>;
  }
  return (
    <Route
      {...rest}
      render={({ props, location }) =>
        Authenticated ? <MasterLayout {...props} /> : <></>
      }
    />
  );
};

export default AdminPrivateRoute;
